export default {
    'ad_project': 'AD CASA',
    'menu_projects': 'Projects',
    'menu_company': 'About',
    'menu_contacts': 'Contact us',
    'section_architecture': 'Architecture',
    'section_interior': 'Interior',
    'section_landscape': 'Ladnscape',
    'section_design': 'Design',
    'section_all': 'All',
    'projects_title': 'Projects',
    'all_projects': 'All projects',
    'company': 'About',
    'company_left': 'Company',
    'team': 'Team',
    'whoWeAre': 'Who we are',
    'project_about': 'About project',
    'project_short': 'In short',
    'project_team': 'Team',
    'project_publications': 'Publications',
    'project_awards': 'Awards',
    'project_next': 'Next project',
    'contacts_title': 'Contacts',
    'contacts_city': 'RF, Rostov-on-Don',
    'contacts_address': '16, Krasnih Zor st.',
    'contacts_phone': 'phone',
    'contacts_email': 'email',
    'contacts_feedback': 'Feedback',
    'contacts_sent': 'Sent!',
    'contacts_weWillContact': 'We will contact you soon',
    'contacts_orContactHere': 'or contact us right here',
    'contacts_form_name': 'Your name',
    'contacts_form_phone': 'Phone',
    'contacts_form_email': 'Email',
    'contacts_form_message': 'Your message',
    'contacts_form_send': 'Send',
    'contacts_form_ok': 'OK',
    'contacts_form_sending': 'Sending...',
    'project_location': 'location',
    'project_size': 'area',
    'project_work_period': 'work period',
    'project_building': 'building',
    'project_inside': 'inside',
    'project_release': 'opened',
    'our_clients': 'Our clients',
}